import {DrawerProps} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {ProductLineItem} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: ProductLineItem,
        // Resolves true when the record was saved. The drawer closes ONLY then: a server
        // error leaves it open with the operator's values.
        handleSubmit: (values: ProductLineItem) => Promise<boolean>
    }) => {

    const title = record?.id ? I18n.get('Edit Product Line Item') : I18n.get('Add Product Line Item');

    const handleFormSubmit = async (values: ProductLineItem) => {
        const saved = await handleSubmit(values);
        if (saved) {
            onClose();
        }
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
